import {
    ADD_SUBJECT,
    DELETE_SUBJECT,
    CLEAR_SUBJECT,
    SET_SUBJECT,
    MERCHANT_NAME,
    AGENT_SURNAME,
    AGENT_NAME,
    AGENTPAT_RONYMIC,
    PHONE,
    EMAIL,
    EDIT_SUBJECT,
    SAVE_EDIT_SUBJECT,
    REGION,
    SPSZN,
    COMMUNITY_NAME,
    ADDRESS,
    COMMUNITY_PHONE,
    COMMUNITY_EMAIL,
    COMMUNITY_URL,
    COMMUNITY_COUNT,
    I_CODE_RADA,
    SET_CURRENT_USER
} from '../actions/socialComuniti.action'

import isEmpty from '../../vibe/components/utilities/MainUtils/is-empty';

const initialState = {
    isAuthenticated: false,

    "certSerialNumber": "",
    "serialNumberIssuer": "",
    "serialNumberSubject": "",
    "itn": "",
    "commonName": "",
    "signerSurname": "",
    "signerName": "",
    "signerPatronymic": "",
    "title": "",
    "state": "",
    "locality": "",
    "organization": "",
    "iCodeSigner": "",
    // signerSurname: '',
    // signerName: '',
    // signerPatronymic: '',
    // state: '',
    // locality: '',
    // organization: '',

    communityName: '',
    address: '',
    phone: '',
    email: '',
    url: '',
    iCodeRada: '',
    count: '',
    requestDetails: [],
    merchantName: '',
    agentSurname: '',
    agentName: '',
    agentPatronymic: '',
    // phone: '',
    // email: '',
    regionId: '',
    spsznId: '',
    communityEmail: '',
    communityPhone: '',
    // url: ''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_CURRENT_USER:
        return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        ...action.payload
        }
      
        case ADD_SUBJECT:
            return {
                ...state,
                requestDetails: [
                    ...state.requestDetails, 
                    action.payload
                ]
            };
            case SET_SUBJECT:
            return {
                ...state,
                requestDetails: action.payload
            };
            case MERCHANT_NAME:
                return {
                    ...state,
                    merchantName: action.payload
                    
                };
                case AGENT_SURNAME:
                return {
                    ...state,
                    agentSurname: action.payload
                    
                };

                case AGENT_NAME:
                return {
                    ...state,
                    agentName: action.payload
                    
                };
                case AGENTPAT_RONYMIC:
                    return {
                        ...state,
                        agentPatronymic: action.payload
                        
                    };

                    case PHONE:
                    return {
                        ...state,
                        phone: action.payload
                        
                    };

                    case EMAIL:
                    return {
                        ...state,
                        email: action.payload
                        
                    };



                case SAVE_EDIT_SUBJECT:
                    return {
                        ...state,
                        requestDetails: state.requestDetails.map((item, index) => {
                            return index === action.payload.index ? {...item, ...action.payload.data} : {...item}
                        })
                        
                    };
                case EDIT_SUBJECT:
                    return {
                        ...state,
                        ...action.payload
                        
                    };
                case CLEAR_SUBJECT:
                    return {
                        ...state,
                        merchantName: "",
                        agentSurname: '',
                        agentName: '',
                        agentPatronymic: '',
                        phone: '',
    email: '',
                        
                    };
                    case REGION:
                        return {
                            ...state,
                            regionId: action.payload,
                            spsznId: ''
                            
                        };
                        case SPSZN:
                            return {
                                ...state,
                                spsznId: action.payload
                            };
                            case I_CODE_RADA:
                            return {
                                ...state,
                                iCodeRada: action.payload
                            };
                            case COMMUNITY_COUNT:
                                return {
                                    ...state,
                                    count: action.payload
                                };
                                case COMMUNITY_URL:
                                    return {
                                        ...state,
                                        url: action.payload
                                    };
                                    case COMMUNITY_EMAIL:
                                        return {
                                            ...state,
                                            communityEmail: action.payload
                                        };
                                        case COMMUNITY_PHONE:
                                            return {
                                                ...state,
                                                communityPhone: action.payload
                                            };
                                            case ADDRESS:
                                                return {
                                                    ...state,
                                                    address: action.payload
                                                };
                                                case COMMUNITY_NAME:
                                                    return {
                                                        ...state,
                                                        communityName: action.payload
                                                    };
                case DELETE_SUBJECT:
                    return {
                        ...state,
                        requestDetails: state.requestDetails.filter((item, index) => index !== action.payload)
                    };
            default:
                return state;
        }
    }

